<template>
  <div>
    <v-card>
      <template v-if="onPage==='dashboard'">
        <v-card-title>
          My Tickets
        </v-card-title>
      </template>
      <v-card-text>

        <template>
          <v-chip-group column>
            <template v-if="!getTicketsConfigs.escalation">
              <v-chip @click:close="clearSingleFilter({filter:'kind__in',value:null})" close small v-if="hasValue(getTicketsConfigs.queryParams.kind__in)"><b class="mr-1">Kind:</b>{{getTicketsConfigs.queryParams.kind__in.join(', ')}}</v-chip>
              <v-chip @click:close="clearSingleFilter({filter:'status__in',value:null})" close small v-if="hasValue(getTicketsConfigs.queryParams.status__in)"><b class="mr-1">Status:</b>{{getTicketsConfigs.queryParams.status__in.join(', ')}}</v-chip>
              <v-chip @click:close="clearSingleFilter({filter:'agent__in',value:null})" :close="this.onPage!=='dashboard'" small v-if="hasValue(getTicketsConfigs.queryParams.agent__in)"><b class="mr-1">Agent:</b>{{getTicketsConfigs.queryParams.agent__in.join(', ')}}</v-chip>
              <v-chip @click:close="clearSingleFilter({filter:'escalation_agent__in',value:null})" :close="this.onPage!=='dashboard'" small v-if="hasValue(getTicketsConfigs.queryParams.escalation_agent__in)"><b class="mr-1">Escalation agent:</b>{{getTicketsConfigs.queryParams.escalation_agent__in.join(', ')}}</v-chip>
              <v-chip @click:close="clearSingleFilter({filter:'team__in',value:null})" close small v-if="hasValue(getTicketsConfigs.queryParams.team__in)"><b class="mr-1">Department:</b>{{getTicketsConfigs.queryParams.team__in.join(', ')}}</v-chip>
              <v-chip @click:close="clearSingleFilter({filter:'cause__in', value:null})" close small v-if="hasValue(getTicketsConfigs.queryParams.cause__in)"><b class="mr-1">Cause:</b>{{ ticketCauses }}</v-chip>
              <v-chip @click:close="clearSingleFilter({filter:'creation_timestamp__gte', value: null}); clearSingleFilter({filter:'creation_timestamp__lte', value: null})" close small v-if="getTicketsConfigs.queryParams.creation_timestamp__gte && getTicketsConfigs.queryParams.creation_timestamp__lte"><b class="mr-1">Created:</b>{{ getTicketsConfigs.queryParams.creation_timestamp__gte | formatDateWithoutTime }} to {{ getTicketsConfigs.queryParams.creation_timestamp__lte | formatDateWithoutTime }}</v-chip>
              <v-chip @click:close="clearSingleFilter({filter:'supplier_ticket_id', value:null})" close small v-if="getTicketsConfigs.queryParams.supplier_ticket_id"><b class="mr-1">Supplier ticket ID:</b>{{ getTicketsConfigs.queryParams.supplier_ticket_id }}</v-chip>
            </template>
            
            <v-chip @click:close="clearSingleFilter({filter:'escalation',value:false})" close small v-if="getTicketsConfigs.escalation"><b class="mr-1">Escalations</b></v-chip>
          </v-chip-group>
        </template>

        <v-data-table :loading="getTicketsLoading" :headers="headers" :items="getTickets" :expanded.sync="expanded" show-expand class="body--text" :server-items-length="getTicketsConfigs.paginationCount" :page.sync="options.pagination.page" :options.sync="options.pagination" :footer-props="{itemsPerPageOptions: itemsPerPageOptions}" @click:row="goToCRM" single-expand>

          <template v-slot:item.is_escalation="{ item }"><v-icon color="error" v-if="item.is_escalation">{{escalationIcon}}</v-icon></template>
          <template v-slot:item.product_id="{ item }"><a @click.stop="goToProduct(item.product_id)">{{ item.product_id | customPlaceholder }}</a></template>
          <template v-slot:item.supplier_ticket_id="{ item }">{{ item.supplier_ticket_id | customPlaceholder }}</template>
          <template v-slot:item.type="{ item }">{{ item.type }}</template>
          <template v-slot:item.status="{ item }">{{ item.status }}</template>
          <template v-slot:item.agent="{ item }">{{ item.agent }}</template>
          <template v-slot:item.department="{ item }">{{ item.department }}</template>
          <template v-slot:item.last_changed="{ item }">{{ item.last_changed | formatDate }}</template>

          <template v-slot:item.age="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">{{ item.age }}</span>
              </template>

              <span>{{ item.creation_timestamp | formatDate }}</span>
            </v-tooltip>           
          </template>

          <template v-slot:item.next_follow_up_date="{ item }">{{ item.next_follow_up_date | formatDate }}</template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">

              <v-row align="center" justify="center" no-gutters class="py-3">

                <v-col cols="12" class="mb-2">
                  <span class="font-weight-bold">Description: </span>{{ item.description | customPlaceholder }}
                </v-col>

                <v-col cols="12" class="mb-2">
                  <span class="font-weight-bold">Cause summary: </span>{{ item.cause_summary | customPlaceholder }}
                </v-col>

                <v-col cols="12" class="mb-2">
                  <span class="font-weight-bold">Outcome: </span>{{ item.outcome | customPlaceholder }}
                </v-col>

              </v-row>
              
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { mdiAlert } from '@mdi/js';
  import { mapGetters,mapActions,mapMutations } from "vuex";
  const OLD_CRM_LINK = process.env.VUE_APP_API_HOST || `https://ctst-testing.appspot.com/`;
  import moment from "moment";

  export default {
    props: ['onPage'],

    data() {
      return {
        crmLink: OLD_CRM_LINK,
        escalationIcon: mdiAlert,
        options: {
          pagination: {
            page: 1,
            itemsPerPage: 25,
            sortBy: [],
            sortDesc: [],
          },
          queryParams: {},
          product_id: null,
        },
        itemsPerPageOptions: [5,10,15,25,50],
        expanded: [],
        OLD_CRM_LINK: process.env.VUE_APP_API_HOST || `https://ctst-testing.appspot.com/`,
        headers: [
          { text: '', value: 'is_escalation',sortable: false },
          { text: 'Product ID', value: 'product_id',sortable: false },
          { text: 'Supplier ticket ID', value: 'supplier_ticket_id',sortable: false },
          { text: 'Ticket Type', value: 'type',sortable: false },
          { text: 'Status', value: 'status',sortable: false },
          { text: 'Agent', value: 'agent',sortable: false },
          { text: 'Escalation agent', value: 'escalation_agent',sortable: false },
          { text: 'Department', value: 'department',sortable: false },
          { text: 'Last updated', value: 'last_changed',sortable: true },
          { text: 'Age', value: 'age',sortable: true },
          { text: 'Next Follow Up', value: 'next_follow_up_date',sortable: true },
          { text: '', value: 'data-table-expand',sortable: false },
        ],
      }
    },

    filters: {
      formatStatus(val) {
        const map = {"voip": "VoIP", "web": "Website", "telco": "Telco"};
        return map[val];
      }
    },

    computed: {
      ...mapGetters("auth", ["getUser"]),
      ...mapGetters('tickets', ['getTickets', 'getTicketsLoading', 'getTicketsConfigs', 'getTicketCause']),

      ticketCauses() {
        return this.getTicketsConfigs.queryParams.cause__in.map(cause => this.getTicketCause(cause)).join(', ');
      },

      getSort() {
        if(this.options.pagination.sortBy[0] === "age") {
          return ["creation_timestamp"];
        }
        return this.options.pagination.sortBy[0] || "";
      },

      getOrder() {
        if(this.options.pagination.sortDesc.length && this.options.pagination.sortDesc[0] === true) return "desc";
        if(this.options.pagination.sortDesc.length && this.options.pagination.sortDesc[0] === false) return "asc";
        return '';
      },

      hasValue() {
        return (val) => val && val.length;
      }
    },

    methods: {
      ...mapActions('tickets', ['fetchTickets','updateTicketsPagination','updateDashboardTicketsPagination','resetTicketStore']),
      ...mapMutations('tickets', ['setPageType','setCurrentUser']),

      clearSingleFilter(item){
        this.options.pagination.page = 1; 

        let options = {
          pagination: {
            page: 1,
          },
          queryParams: {
            status__in: this.getTicketsConfigs.queryParams.status__in,
            agent__in: this.getTicketsConfigs.queryParams.agent__in,
            escalation_agent__in: this.getTicketsConfigs.queryParams.escalation_agent__in,
            team__in: this.getTicketsConfigs.queryParams.team__in,
            kind__in: this.getTicketsConfigs.queryParams.kind__in,
            cause__in: this.getTicketsConfigs.queryParams.cause__in,
            creation_timestamp__gte: this.getTicketsConfigs.queryParams.creation_timestamp__gte,
            creation_timestamp__lte: this.getTicketsConfigs.queryParams.creation_timestamp__lte,
            supplier_ticket_id: this.getTicketsConfigs.queryParams.supplier_ticket_id,
          }
        };

        options.queryParams[item.filter] = item.value;

        if(this.onPage === 'dashboard') {
          this.updateDashboardTicketsPagination(options);
        } else {
          this.updateTicketsPagination(options);
        }
      },

      goToProduct(id){
        const route = this.$router.resolve({ path: `/products/${id}/` });
        window.open(route.href, '_blank');
      },

      goToCRM(item){
        this.$router.push(`/tickets/${item.id}/`);
      }
    },

    beforeDestroy() {
      this.resetTicketStore();
    },

    created() {
      const sales_person = this.getUser.email.split("@")[0];
      this.setPageType((this.onPage!==undefined)?this.onPage:'tickets');
      this.setCurrentUser((this.onPage==='dashboard')?sales_person:'');

      if(this.onPage === "dashboard") {
        this.options.queryParams.agent__in = [sales_person];
        this.options.pagination.sortBy = ["next_follow_up_date"];
        this.options.pagination.sortDesc = [true];
        this.options.queryParams.status__in = ['new','open','pending','escalation'];
      } else {
        const localParams = JSON.parse(localStorage.getItem('ticket-filters'));
        const routeParams = JSON.parse(JSON.stringify(this.$route.query));
        let queryParams = null;

        if(Object.keys(routeParams).length) {
          queryParams = routeParams;
        } else if(localParams && moment(localParams.date).isAfter(moment().subtract(1, 'hours'))) {
          queryParams = Object.entries(localParams).reduce((acc, [k, v]) => {
            if(Array.isArray(v)) {
              acc[k] = v.join(",");
            } else {
              acc[k] = v;
            }
            return acc;
          }, {});
        }

        if(queryParams && Object.keys(queryParams).length) {
          if (queryParams.product_id) {
            this.options.pagination.sortBy = [];
            this.options.pagination.sortDesc = [];
            this.options.queryParams.product_id = this.$route.query.product_id;
          } else {
            this.options.pagination.page = parseInt(queryParams.page);
            this.options.pagination.itemsPerPage = parseInt(queryParams.limit);
            this.options.pagination.sortBy = queryParams.sort ? [queryParams.sort] : [];
            this.options.pagination.sortDesc = queryParams.order === 'asc' ? [false] : queryParams.order === 'desc' ? [true] : [true];
            this.options.queryParams = { ...queryParams };
          }
        } else {
          this.options.page = 1;
          this.options.pagination.itemsPerPage = 25;
          this.options.pagination.sortBy = ["next_follow_up_date"];
          this.options.pagination.sortDesc = [true];
          this.options.queryParams.status__in = ['new','open','pending','escalation'];
          this.options.queryParams.product_id = null;
        }
      }

    },

    watch: {
      "options.pagination": {
        immediate: false,
        handler () {
          const query = { 
            pagination: {
              page: this.options.pagination.page,
              limit: this.options.pagination.itemsPerPage,
              sort: this.getSort,
              order: this.getOrder,
            },
            queryParams: this.options.queryParams
          };
          
          if(this.onPage === "dashboard") {
            this.updateDashboardTicketsPagination(query);
          } else {
            this.updateTicketsPagination(query);
          }

          if(this.options.queryParams) {
            delete this.options.queryParams;
          }
        },
        deep: true,
      },
    },
  }
</script>

<style lang="scss" scoped>
  .v-data-table ::v-deep tbody tr {
    cursor: pointer !important;
  }
</style>
